import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";


const chatSlice = createSlice({
    name: "chat",
    initialState: {
        chats: [], // chatId: [messages | { id, sender, text, timestamp, status }]
        activeChatId: null,
        status: "idle", // idle | loading | succeeded | failed
        error: null,
    },
    reducers: {
        addMessage: (state, action) => {
            const { chatId, message } = action.payload;
            let chat = state.chats.find(chat => chat.id === chatId);
            if (!chat) {
                chat = { id: chatId, name: `NewChat`, messages: [] };
                state.chats.push(chat);
            }
            chat.messages.push(message);
        },
        updateChatId: (state, action) => {
            const { tempId, chatId } = action.payload;
            state.chats = state.chats.map(chat => 
                chat.id === tempId ? { ...chat, id: chatId } : chat
            )
        },
        updateMessageStatus: (state, action) => {
            const { chatId, tempId, newMessage } = action.payload;
            const chat = state.chats.find(chat => chat.id === chatId);
            if (chat) {
                chat.messages = chat.messages.map(msg =>
                    msg.id === tempId ? { ...newMessage, status: "sent" } : msg
                );
            }
        },
        markMessageFailed: (state, action) => {
            const { chatId, tempId } = action.payload;
            const chat = state.chats.find(chat => chat.id === chatId);
            if (chat) {
                chat.messages = chat.messages.map(msg =>
                    msg.id === tempId ? { ...msg, status: "failed" } : msg
                );
            }
        },
        clearChat: (state, action) => {
            const { chatId } = action.payload;
            state.chats[chatId] = [];
        },
        setActiveChat: (state, action) => {
            state.activeChatId = action.payload;
        },
        setChats: (state, action) => {
            state.chats = action.payload;
        },
        deleteChat: (state, action) => {
            state.chats = state.chats.filter(chat => chat.id !== action.payload);
        },
        setStatus: (state, action) => {
            state.status = action.payload;
        },
        setError: (state, action) => {
            state.error = action.payload;
            state.status = "failed";
        }
    },
});

export const { addMessage, clearChat, setActiveChat, setChats, deleteChat, updateChatId } = chatSlice.actions;
export default chatSlice.reducer;